import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const SessionExpiredModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={null}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          pt: 4,
          pb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "#FFF3E0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: "pulse 2s ease-in-out infinite",
              "@keyframes pulse": {
                "0%, 100%": {
                  transform: "scale(1)",
                  opacity: 1,
                },
                "50%": {
                  transform: "scale(1.05)",
                  opacity: 0.9,
                },
              },
            }}
          >
            <ErrorOutlineIcon
              sx={{
                fontSize: 48,
                color: "#FF9800",
              }}
            />
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: "#FF9800",
            }}
          >
            Session Expired
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          textAlign: "center",
          pb: 3,
          px: 4,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "#555",
            mb: 2,
            lineHeight: 1.6,
          }}
        >
          Your session has expired due to inactivity or security reasons.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#777",
            fontStyle: "italic",
          }}
        >
          Please login again to continue.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 3,
          px: 3,
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{
            px: 5,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: 600,
            background: "linear-gradient(45deg, #FF9800 30%, #FFB74D 90%)",
            boxShadow: "0 3px 8px rgba(255, 152, 0, 0.3)",
            "&:hover": {
              background: "linear-gradient(45deg, #F57C00 30%, #FF9800 90%)",
              boxShadow: "0 4px 12px rgba(255, 152, 0, 0.4)",
            },
          }}
        >
          Login Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredModal;
